import lrsAdapter from '../../helpers/lrs_adapter'
import getAxiosInstance from '../../helpers/get_axios_instance'

class Biotecnologia {
  static getBiotecnologiasByCereal (cereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(
      `biotecnologia_cereal?r={"clave": {"cereal": "${cereal}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  };
}

export default Biotecnologia
